<template>
    <add-edit-section></add-edit-section>
</template>

<script>
import AddEditSection from "@/layouts/components/masters/section-subsection/addedit-section.vue";
export default {
 components : {
   AddEditSection
 },
};
</script>